
















































































import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { VIPCompany, VIPContactRest, db, auth } from '@/loader';
import EntityTable from '@/component/EntityTable';
import { BvTableCtxObject, BvTableFieldArray } from 'bootstrap-vue';
import { VIPContactRefreshTableMixin } from '@/mixins/VIPContactMixin';

@Component
export default class ContactsTable extends Mixins(VIPContactRefreshTableMixin) {
	@Prop({ type: VIPCompany, required: true })
	public company!: VIPCompany;

	public get canCreate(): boolean {
		return auth.user?.capabilities.create_vip_company || false;
	}

	public get fields(): BvTableFieldArray {
		return [
			{
				key: "last_name",
				label: "Nom",
				sortable: !this.noSorting,
			},
			{
				key: "first_name",
				label: "Prénom",
				sortable: !this.noSorting,
			},
			{
				key: "phone",
				label: "Téléphone",
				sortable: !this.noSorting,
			},
			{
				key: "email",
				label: "Email",
				sortable: !this.noSorting,
			},
		];
	}

	public getContacts(context: BvTableCtxObject, callback: Function) {
		VIPContactRest.list({
			page: context.currentPage,
			per_page: context.perPage,
			search: context.filter,
			orderby: context.sortBy || "last_name",
			order: context.sortDesc ? "desc" : "asc",
			fk_company: this.company.id,
		}).then(result => {
			this.setResult(callback, result);
		});
		return null;
	}

	@Watch("company")
	public companyChanged(newValue, oldValue) {
		this.filterChanged();
	}
}
